import React, { Component } from 'react';
import { func } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import cs from 'classnames';
import { Box } from '@mui/material';
import { Button } from '../../components/Button';

class ServerErrorPage extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    setServerError: func,
  };

  shouldComponentUpdate() {
    return false;
  }
  componentWillUnmount() {
    this.props.setServerError();
  }

  handleGoHomeClick = () => {
    this.props.setServerError();

    window.location.href = '/';
  };

  render() {
    return (
      <Box className="app-wrapper" sx={{ width: '100%' }}>
        <div
          className={cs([
            'app-wrapper',
            'page-error-container',
            'animated',
            'slideInUpTiny',
            'animation-duration-3',
          ])}
        >
          <div className="page-error-content">
            <Box className="error-code animated zoomInDown" sx={{ mb: 3 }}>
              500
            </Box>
            <Box
              component="h2"
              className="fw-regular title bounceIn animation-delay-10 animated"
              sx={{ textAlign: 'center' }}
            >
              <span>{this.props.intl.formatMessage({ id: 'extraPages.500Msg' })}</span>
            </Box>
            <Box className="zoomIn animation-delay-20 animated" sx={{ textAlign: 'center' }}>
              <Button
                labelId="extraPages.goHome"
                onClick={this.handleGoHomeClick}
                variant="contained"
                color="primary"
                size="small"
              />
            </Box>
          </div>
        </div>
      </Box>
    );
  }
}

export default injectIntl(ServerErrorPage);
